
export {Font,
FontBackgroundColor,
FontBackgroundColorCommand,
FontBackgroundColorEditing,
FontBackgroundColorUI,
FontColor,
FontColorCommand,
FontColorEditing,
FontColorUI,
FontColorUIBase,
FontCommand,
FontFamily,
FontFamilyCommand,
FontFamilyEditing,
FontFamilyUI,
FontSize,
FontSizeCommand,
FontSizeEditing,
FontSizeUI,
_addFontColorSelectorToDropdown,
_buildFontDefinition,
_normalizeFontFamilyOptions,
_normalizeFontSizeOptions,
_renderDowncastFontElement,
_renderUpcastFontColorAttribute} from '../../../frontend-editor-ckeditor-web/__liferay__/exports/@ckeditor$ckeditor5-font$dist$index.js.js';
